import { render, staticRenderFns } from "./changeteminalinfo.vue?vue&type=template&id=83b0988e&"
import script from "./changeteminalinfo.vue?vue&type=script&lang=js&"
export * from "./changeteminalinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports